// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/ConstructionServices.tsx

import HeroBanner from "../../components/HeroBanner.tsx";
import Counter from "../../components/Counter.tsx";
import Showcase from "../../components/Showcase.tsx";
import PartnerGrid from "../../components/PartnerGrid.tsx";
import CareersBanner from "../../components/CareersBanner.tsx";
import ESG from "../../components/ContentCard.tsx";
import ContactPerson from "../../components/ContactPerson.tsx";
import AnchorMenu from "../../components/AnchorMenu.tsx";
import { useLanguage } from "../../lang/index.lang.tsx";

const ConstructionServices = () => {
  const { t } = useLanguage();

  return (
    <>
      <AnchorMenu
        title={t("services.construction-services.title")}
        titleLink="#services"
        items={[      
          { id: "Title", label: t("counter.heading.title"), anchor: "Counter" },   
          { id: "2", label: t("services.heading.AllServices"), anchor: "AllServices" },          
          { id: "3", label: t("navigation.career"), anchor: "Careers" },
          { id: "4", label: t("services.heading.partner"), anchor: "Partner" },           
          { id: "5", label: t("anchor.contactPersons"), anchor: "ContactPersons" },
          { id: "6", label: t("home.esg.heading.subtitle"), anchor: "esg" },   
        ]}
      />

      <section id="Services">
        <HeroBanner
          image="/images/EST-1344212168.jpg"
          department={t("services.construction-services.department")}
          header={t("services.construction-services.header")}
          welcome={t("services.construction-services.welcome")}
          title={t("services.construction-services.description.short")}
          description={t("services.construction-services.description.long")}
          buttonText={t("common.learnMore")}
          buttonLink="#"
        />
      </section>

      <section id="Counter">
      <Counter 
        items={[
          {
            key: "industriesServed",
            endValue: 10,
            prefix: "",
            suffix: "+",
          },
          {
            key: "buildingVolume",
            endValue: 100,
            prefix: "",
            suffix: " Mio. EUR+",
          },          
          {
            key: "realizedSquareMeters",
            endValue: 75000,
            prefix: "",
            suffix: "+",
          },
          {
            key: "realizedProjects",
            endValue: 200,
            prefix: "",
            suffix: "+",
          },
        ]}
        sectionTitle={t("services.construction-services.title")}
        mainTitle={t("counter.heading.title")}
      />
      </section>

      

      <section id="AllServices">
        <Showcase
          heading={{
            subtitle: t("services.construction-services.title"),
            title: t("services.construction-services.header"),
            explore: t("services.construction-services.explore"),           
          }}        
          items={[            
            {
              id: 1,
              title: t("services.interior-fitout.title"),
              subtitle: t("services.interior-fitout.description.short"),
              description: t("services.interior-fitout.description.long"),
              link: "",
            },                
            {
              id: 2,
              title: t("services.hklse.title"),
              subtitle: t("services.hklse.description.short"),
              description: t("services.hklse.description.long"),
              link: "",
            },
            {
              id: 3,
              title: t("services.building-refurbishment.title"),
              subtitle: t("services.building-refurbishment.description.short"),
              description: t("services.building-refurbishment.description.long"),
              link: "",
            },     
            {
              id: 4,
              title: t("services.heating-energy-services.title"),
              subtitle: t("services.heating-energy-services.description.short"),
              description: t("services.heating-energy-services.description.long"),
              link: "",
            },
            
          ]}        
          learnMoreText={t("services.heading.learnMore")}
        />
      </section>

      <section id="Careers">
        <CareersBanner
          image="/images/EST-6372937.jpg"
          title={t("home.heroBanner.title")}
          description={t("home.heroBanner.description")}
          buttonText={t("home.heroBanner.buttonText")}
          buttonLink="/careers"
        />
      </section>

      <section id="Partner">
        <PartnerGrid />
      </section>
      

      <section id="ContactPersons">
        <ContactPerson
          heading={{
            subtitle: t("services.construction-services.department"),
            title: t("services.heading.contact-person"),
          }}
          employeeIds={["SR"]}
        />
      </section>

      <section id="esg">
        <ESG
          heading={{
            title: t("home.esg.heading.title"),    
            description: t("home.esg.heading.description"),       
          }}
          data={[
            {
              id: 1,
              title: t("home.esg.s.title"),
              description: t("home.esg.s.description"),
              image: "/images/EST-1385648186.jpg",
              category: t("home.esg.s.category"),
              buttonText: t("home.esg.s.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 2,
              title: t("home.esg.e.title"),
              description: t("home.esg.e.description"),
              image: "/images/EST-599972772.jpg",
              category: t("home.esg.e.category"),
              buttonText: t("home.esg.e.buttonText"),
              buttonLink: "/about",
            },          
            {
              id: 3,
              title: t("home.esg.g.title"),
              description: t("home.esg.g.description"),
              image: "/images/EST-12499784456.jpg",
              category: t("home.esg.g.category"),
              buttonText: t("home.esg.g.buttonText"),
              buttonLink: "/about",
            },          
          ]}
        />
      </section>

    </>
  );
};

export default ConstructionServices;